import { render, staticRenderFns } from "./addSegmentContact.vue?vue&type=template&id=59384296&lang=pug"
import script from "./addSegmentContact.vue?vue&type=script&lang=js"
export * from "./addSegmentContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports